// Converteer MyLaps/AMB transponder nummers naar leesbaar formaat (bijv. FX-82427)
// en terug. Algoritme reverse-engineered uit MylapsSDK.dll.

const FX_CHARS = 'CFGHKLNPRSTVWXZ';

export function toDisplayId(transponder) {
  const n = (Number(transponder) >>> 0);
  const masked = n & 0x1FFFFFFF;
  if (masked < 0x06000000) return String(n);
  const N = (masked + 0xFA000000) >>> 0;
  const unit = N % 100000;
  let Q = Math.floor(N / 100000);
  let prefix = '';
  do {
    prefix = FX_CHARS[Q % 15] + prefix;
    Q = Math.floor(Q / 15);
  } while (Q > 0);
  // Prefix altijd minimaal 2 tekens; FX_CHARS[0] ('C') is de base-15 "nul-digit",
  // dus links aanvullen is waardebehoudend en round-trip-veilig via toNumeric().
  return `${prefix.padStart(2, FX_CHARS[0])}-${String(unit).padStart(5, '0')}`;
}

export function toNumeric(displayId) {
  if (!displayId) return null;
  const s = String(displayId).trim().toUpperCase();
  if (/^\d+$/.test(s)) return parseInt(s, 10);
  const m = /^([A-Z]+)-(\d{1,5})$/.exec(s);
  if (!m) return null;
  let Q = 0;
  for (const ch of m[1]) {
    const i = FX_CHARS.indexOf(ch);
    if (i === -1) return null;
    Q = Q * 15 + i;
  }
  const N = Q * 100000 + parseInt(m[2], 10);
  return ((N + 0x06000000) & 0xFFFFFFFF) >>> 0;
}

// Valideer of een string een geldig display formaat is (bijv. "FX-82427")
export function isValidDisplayId(s) {
  if (!s) return false;
  return /^[A-Z]+-\d{1,5}$/i.test(s.trim());
}
